import { render } from "./Baluchon.vue?vue&type=template&id=5ec33714"
import script from "./Baluchon.vue?vue&type=script&lang=js"
export * from "./Baluchon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__